const Papa = require('papaparse');

const GeckoParser = {
  readCsv: (file, header = false, skipEmptyLines = true) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header,
        complete: (results, file) => {
          const { errors } = results;
          if (errors.length > 0) {
            const { row, message } = errors[0];
            return reject(`${message} on row ${row}.`);
          }
          return resolve(results);
        },
        error: (error, file) => {
          return reject(error);
        },
        skipEmptyLines,
      });
    });
  },
  /**
   * Parse each row of a CSV already converted to an object
   *
   * @see - https://stackoverflow.com/questions/171480/regex-grabbing-values-between-quotation-marks
   */
  parseCsv: (rawData) => {
    return rawData.map((row, index) => {
      // Find all items in a string that are grouped by double quotes.
      //
      // Including those that span accross multiple lines i.e if the
      // string within the double quotes have a newline.
      //
      // e.g `"i am the fist one" "i am the second one"`
      const regex = /(["])(\\?.|\n)*?\1/gm;
    });
  },
};

export default GeckoParser;
